export const TIPOS_LOGRADOURO = [
  { nu_dne: '678', no_tipo_logradouro: 'AVENIDA VELHA' },
  { nu_dne: '009', no_tipo_logradouro: 'BALNEÁRIO' },
  { nu_dne: '019', no_tipo_logradouro: 'CHAPADÃO' },
  { nu_dne: '038', no_tipo_logradouro: 'FERROVIA' },
  { nu_dne: '560', no_tipo_logradouro: '9ª RUA' },
  { nu_dne: '088', no_tipo_logradouro: 'RETIRO' },
  { nu_dne: '558', no_tipo_logradouro: '7ª RUA' },
  { nu_dne: '664', no_tipo_logradouro: 'CONJUNTO MUTIRÃO' },
  { nu_dne: '563', no_tipo_logradouro: '12ª RUA' },
  { nu_dne: '561', no_tipo_logradouro: '10ª RUA' },
  { nu_dne: '477', no_tipo_logradouro: 'MARINA' },
  { nu_dne: '562', no_tipo_logradouro: '11ª RUA' },
  { nu_dne: '705', no_tipo_logradouro: 'ENSEADA' },
  { nu_dne: '704', no_tipo_logradouro: 'ENTRE BLOCO' },
  { nu_dne: '498', no_tipo_logradouro: 'ESTÂNCIA' },
  { nu_dne: '706', no_tipo_logradouro: 'ILHOTA' },
  { nu_dne: '749', no_tipo_logradouro: 'MÓDULO COMERCIAL' },
  { nu_dne: '471', no_tipo_logradouro: 'PARADOURO' },
  { nu_dne: '500', no_tipo_logradouro: 'NÚCLEO' },
  { nu_dne: '718', no_tipo_logradouro: 'PROJEÇÃO' },
  { nu_dne: '694', no_tipo_logradouro: 'QUARTA LADEIRA' },
  { nu_dne: '695', no_tipo_logradouro: 'QUINTA LADEIRA' },
  { nu_dne: '475', no_tipo_logradouro: 'QUINTAS' },
  { nu_dne: '662', no_tipo_logradouro: 'RECREIO' },
  { nu_dne: '670', no_tipo_logradouro: 'RUA INTEGRAÇÃO' },
  { nu_dne: '701', no_tipo_logradouro: 'SEGUNDA AVENIDA' },
  { nu_dne: '673', no_tipo_logradouro: 'TRAVESSA VELHA' },
  { nu_dne: '505', no_tipo_logradouro: 'VIA ELEVADO' },
  { nu_dne: '549', no_tipo_logradouro: '1º PARQUE' },
  { nu_dne: '746', no_tipo_logradouro: '2ª ALAMEDA' },
  { nu_dne: '550', no_tipo_logradouro: '2º PARQUE' },
  { nu_dne: '551', no_tipo_logradouro: '3º PARQUE' },
  { nu_dne: '526', no_tipo_logradouro: '4º ALTO' },
  { nu_dne: '531', no_tipo_logradouro: '4º BECO' },
  { nu_dne: '527', no_tipo_logradouro: '5º ALTO' },
  { nu_dne: '532', no_tipo_logradouro: '5º BECO' },
  { nu_dne: '537', no_tipo_logradouro: '5ª PARALELA' },
  { nu_dne: '559', no_tipo_logradouro: '8ª RUA' },
  { nu_dne: '063', no_tipo_logradouro: 'PASSEIO' },
  { nu_dne: '646', no_tipo_logradouro: 'VIA EXPRESSA' },
  { nu_dne: '540', no_tipo_logradouro: '3ª SUBIDA' },
  { nu_dne: '092', no_tipo_logradouro: 'SÍTIO' },
  { nu_dne: '659', no_tipo_logradouro: '18ª TRAVESSA' },
  { nu_dne: '738', no_tipo_logradouro: 'ANEL VIÁRIO' },
  { nu_dne: '693', no_tipo_logradouro: '3ª LADEIRA' },
  { nu_dne: '743', no_tipo_logradouro: '21ª TRAVESSA' },
  { nu_dne: '675', no_tipo_logradouro: 'ESTRADA DE LIGAÇÃO' },
  { nu_dne: '711', no_tipo_logradouro: 'VIA COSTEIRA' },
  { nu_dne: '099', no_tipo_logradouro: 'TREVO' },
  { nu_dne: '533', no_tipo_logradouro: '1ª PARALELA' },
  { nu_dne: '553', no_tipo_logradouro: '2ª RUA' },
  { nu_dne: '087', no_tipo_logradouro: 'RECANTO' },
  { nu_dne: '715', no_tipo_logradouro: 'MERCADO' },
  { nu_dne: '528', no_tipo_logradouro: '1º BECO' },
  { nu_dne: '552', no_tipo_logradouro: '1ª RUA' },
  { nu_dne: '479', no_tipo_logradouro: 'CIRCULAR' },
  { nu_dne: '503', no_tipo_logradouro: 'COMPLEXO VIÁRIO' },
  { nu_dne: '010', no_tipo_logradouro: 'BELVEDERE' },
  { nu_dne: '710', no_tipo_logradouro: 'ESTRADA INTERMUNICIPAL' },
  { nu_dne: '039', no_tipo_logradouro: 'FONTE' },
  { nu_dne: '098', no_tipo_logradouro: 'TERMINAL' },
  { nu_dne: '007', no_tipo_logradouro: 'ATALHO' },
  { nu_dne: '089', no_tipo_logradouro: 'RETA' },
  { nu_dne: '071', no_tipo_logradouro: 'PROLONGAMENTO' },
  { nu_dne: '669', no_tipo_logradouro: 'RUA PARTICULAR' },
  { nu_dne: '687', no_tipo_logradouro: 'BLOCOS' },
  { nu_dne: '546', no_tipo_logradouro: '3ª VILA' },
  { nu_dne: '002', no_tipo_logradouro: 'ADRO' },
  { nu_dne: '067', no_tipo_logradouro: 'PARADA' },
  { nu_dne: '091', no_tipo_logradouro: 'RETORNO' },
  { nu_dne: '536', no_tipo_logradouro: '4ª PARALELA' },
  { nu_dne: '683', no_tipo_logradouro: '6ª AVENIDA' },
  { nu_dne: '032', no_tipo_logradouro: 'ESTAÇÃO' },
  { nu_dne: '043', no_tipo_logradouro: 'FORTE' },
  { nu_dne: '686', no_tipo_logradouro: 'CONTORNO' },
  { nu_dne: '023', no_tipo_logradouro: 'CAMPO' },
  { nu_dne: '480', no_tipo_logradouro: 'UNIDADE' },
  { nu_dne: '736', no_tipo_logradouro: 'CONJUNTO HABITACIONAL' },
  { nu_dne: '514', no_tipo_logradouro: '8ª TRAVESSA' },
  { nu_dne: '519', no_tipo_logradouro: '13ª TRAVESSA' },
  { nu_dne: '513', no_tipo_logradouro: '7ª TRAVESSA' },
  { nu_dne: '663', no_tipo_logradouro: 'PARQUE MUNICIPAL' },
  { nu_dne: '054', no_tipo_logradouro: 'LARGO' },
  { nu_dne: '716', no_tipo_logradouro: 'EVANGÉLICA' },
  { nu_dne: '547', no_tipo_logradouro: '4ª VILA' },
  { nu_dne: '709', no_tipo_logradouro: '1ª TRAVESSA DA RODOVIA' },
  { nu_dne: '040', no_tipo_logradouro: 'FEIRA' },
  { nu_dne: '097', no_tipo_logradouro: 'TRINCHEIRA' },
  { nu_dne: '502', no_tipo_logradouro: 'PASSAGEM SUBTERRÂNEA' },
  { nu_dne: '737', no_tipo_logradouro: 'JARDIM RESIDENCIAL' },
  { nu_dne: '679', no_tipo_logradouro: 'AVENIDA MARGINAL ESQUERDA' },
  { nu_dne: '676', no_tipo_logradouro: 'ESTRADA ESTADUAL' },
  { nu_dne: '470', no_tipo_logradouro: 'BALÃO' },
  { nu_dne: '645', no_tipo_logradouro: 'ACAMPAMENTO' },
  { nu_dne: '668', no_tipo_logradouro: 'VIA COLETORA' },
  { nu_dne: '719', no_tipo_logradouro: 'NÚCLEO RURAL' },
  { nu_dne: '568', no_tipo_logradouro: 'VARIANTE' },
  { nu_dne: '692', no_tipo_logradouro: '2ª LADEIRA' },
  { nu_dne: '497', no_tipo_logradouro: 'MÓDULO' },
  { nu_dne: '523', no_tipo_logradouro: '1º ALTO' },
  { nu_dne: '539', no_tipo_logradouro: '2ª SUBIDA' },
  { nu_dne: '504', no_tipo_logradouro: 'PRAÇA DE ESPORTES' },
  { nu_dne: '740', no_tipo_logradouro: '17ª TRAVESSA' },
  { nu_dne: '728', no_tipo_logradouro: 'VIA LATERAL' },
  { nu_dne: '721', no_tipo_logradouro: 'ÁREA VERDE' },
  { nu_dne: '037', no_tipo_logradouro: 'FAZENDA' },
  { nu_dne: '030', no_tipo_logradouro: 'ESCADA' },
  { nu_dne: '688', no_tipo_logradouro: 'CICLOVIA' },
  { nu_dne: '522', no_tipo_logradouro: '16ª TRAVESSA' },
  { nu_dne: '524', no_tipo_logradouro: '2º ALTO' },
  { nu_dne: '027', no_tipo_logradouro: 'DESVIO' },
  { nu_dne: '672', no_tipo_logradouro: 'RUA VELHA' },
  { nu_dne: '530', no_tipo_logradouro: '3º BECO' },
  { nu_dne: '012', no_tipo_logradouro: 'BLOCO' },
  { nu_dne: '055', no_tipo_logradouro: 'LAGOA' },
  { nu_dne: '653', no_tipo_logradouro: 'RUA DE LIGAÇÃO' },
  { nu_dne: '730', no_tipo_logradouro: 'AVENIDA MARGINAL NORTE' },
  { nu_dne: '474', no_tipo_logradouro: 'ESPLANADA' },
  { nu_dne: '046', no_tipo_logradouro: 'GRANJA' },
  { nu_dne: '542', no_tipo_logradouro: '5ª SUBIDA' },
  { nu_dne: '717', no_tipo_logradouro: 'CAMPUS' },
  { nu_dne: '747', no_tipo_logradouro: 'VARIANTE DA ESTRADA' },
  { nu_dne: '534', no_tipo_logradouro: '2ª PARALELA' },
  { nu_dne: '033', no_tipo_logradouro: 'ESTÁDIO' },
  { nu_dne: '661', no_tipo_logradouro: '5ª AVENIDA' },
  { nu_dne: '103', no_tipo_logradouro: 'VIADUTO' },
  { nu_dne: '665', no_tipo_logradouro: 'PARQUE RESIDENCIAL' },
  { nu_dne: '108', no_tipo_logradouro: 'ZIGUE-ZAGUE' },
  { nu_dne: '501', no_tipo_logradouro: 'AEROPORTO' },
  { nu_dne: '685', no_tipo_logradouro: 'VIA LITORÂNEA' },
  { nu_dne: '751', no_tipo_logradouro: 'GLEBA' },
  { nu_dne: '555', no_tipo_logradouro: '5ª RUA' },
  { nu_dne: '453', no_tipo_logradouro: 'VEREDA' },
  { nu_dne: '567', no_tipo_logradouro: 'TÚNEL' },
  { nu_dne: '005', no_tipo_logradouro: 'ALTO' },
  { nu_dne: '059', no_tipo_logradouro: 'MORRO' },
  { nu_dne: '481', no_tipo_logradouro: 'CHÁCARA' },
  { nu_dne: '541', no_tipo_logradouro: '4ª SUBIDA' },
  { nu_dne: '724', no_tipo_logradouro: 'RUELA' },
  { nu_dne: '548', no_tipo_logradouro: '5ª VILA' },
  { nu_dne: '660', no_tipo_logradouro: '19ª TRAVESSA' },
  { nu_dne: '696', no_tipo_logradouro: 'PASSAGEM DE PEDESTRES' },
  { nu_dne: '483', no_tipo_logradouro: 'PONTA' },
  { nu_dne: '064', no_tipo_logradouro: 'PÁTIO' },
  { nu_dne: '726', no_tipo_logradouro: 'VIA PRINCIPAL' },
  { nu_dne: '028', no_tipo_logradouro: 'DISTRITO' },
  { nu_dne: '570', no_tipo_logradouro: 'TRAVESSA PARTICULAR' },
  { nu_dne: '045', no_tipo_logradouro: 'GALERIA' },
  { nu_dne: '573', no_tipo_logradouro: 'ENTRADA PARTICULAR' },
  { nu_dne: '658', no_tipo_logradouro: '4ª AVENIDA' },
  { nu_dne: '465', no_tipo_logradouro: 'ARTÉRIA' },
  { nu_dne: '742', no_tipo_logradouro: '20ª TRAVESSA' },
  { nu_dne: '651', no_tipo_logradouro: 'AVENIDA CONTORNO' },
  { nu_dne: '521', no_tipo_logradouro: '15ª TRAVESSA' },
  { nu_dne: '518', no_tipo_logradouro: '12ª TRAVESSA' },
  { nu_dne: '482', no_tipo_logradouro: 'RAMPA' },
  { nu_dne: '566', no_tipo_logradouro: 'RUA DE PEDESTRE' },
  { nu_dne: '062', no_tipo_logradouro: 'PARALELA' },
  { nu_dne: '689', no_tipo_logradouro: 'BULEVAR' },
  { nu_dne: '556', no_tipo_logradouro: '4ª RUA' },
  { nu_dne: '720', no_tipo_logradouro: 'MARGEM' },
  { nu_dne: '680', no_tipo_logradouro: 'AVENIDA MARGINAL DIREITA' },
  { nu_dne: '476', no_tipo_logradouro: 'RÓTULA' },
  { nu_dne: '569', no_tipo_logradouro: 'RODO ANEL' },
  { nu_dne: '722', no_tipo_logradouro: 'CONDOMÍNIO RESIDENCIAL' },
  { nu_dne: '708', no_tipo_logradouro: '2ª TRAVESSA DA RODOVIA' },
  { nu_dne: '013', no_tipo_logradouro: 'BOSQUE' },
  { nu_dne: '016', no_tipo_logradouro: 'CAIS' },
  { nu_dne: '468', no_tipo_logradouro: 'ELEVADA' },
  { nu_dne: '700', no_tipo_logradouro: 'TERCEIRA AVENIDA' },
  { nu_dne: '735', no_tipo_logradouro: 'ESTRADA NOVA' },
  { nu_dne: '496', no_tipo_logradouro: 'BURACO' },
  { nu_dne: '517', no_tipo_logradouro: '11ª TRAVESSA' },
  { nu_dne: '014', no_tipo_logradouro: 'BOULEVARD' },
  { nu_dne: '654', no_tipo_logradouro: 'ÁREA ESPECIAL' },
  { nu_dne: '731', no_tipo_logradouro: 'ESTRADA DE FERRO' },
  { nu_dne: '674', no_tipo_logradouro: 'ANTIGA ESTRADA' },
  { nu_dne: '495', no_tipo_logradouro: 'CANAL' },
  { nu_dne: '036', no_tipo_logradouro: 'FAVELA' },
  { nu_dne: '469', no_tipo_logradouro: 'PORTO' },
  { nu_dne: '082', no_tipo_logradouro: 'RAMAL' },
  { nu_dne: '682', no_tipo_logradouro: 'ESTRADA ANTIGA' },
  { nu_dne: '478', no_tipo_logradouro: 'DESCIDA' },
  { nu_dne: '079', no_tipo_logradouro: 'QUINTA' },
  { nu_dne: '050', no_tipo_logradouro: 'ILHA' },
  { nu_dne: '076', no_tipo_logradouro: 'PONTE' },
  { nu_dne: '707', no_tipo_logradouro: 'VIA DE PEDESTRES' },
  { nu_dne: '515', no_tipo_logradouro: '9ª TRAVESSA' },
  { nu_dne: '557', no_tipo_logradouro: '6ª RUA' },
  { nu_dne: '744', no_tipo_logradouro: '22ª TRAVESSA' },
  { nu_dne: '529', no_tipo_logradouro: '2º BECO' },
  { nu_dne: '554', no_tipo_logradouro: '3ª RUA' },
  { nu_dne: '096', no_tipo_logradouro: 'SUBIDA' },
  { nu_dne: '486', no_tipo_logradouro: 'NÚCLEO HABITACIONAL' },
  { nu_dne: '060', no_tipo_logradouro: 'MONTE' },
  { nu_dne: '741', no_tipo_logradouro: 'ANTIGA ESTAÇÃO' },
  { nu_dne: '565', no_tipo_logradouro: 'VALA' },
  { nu_dne: '015', no_tipo_logradouro: 'BAIXA' },
  { nu_dne: '106', no_tipo_logradouro: 'VALE' },
  { nu_dne: '732', no_tipo_logradouro: 'EIXO PRINCIPAL' },
  { nu_dne: '535', no_tipo_logradouro: '3ª PARALELA' },
  { nu_dne: '697', no_tipo_logradouro: 'ESTRADA VICINAL' },
  { nu_dne: '734', no_tipo_logradouro: 'OUTEIRO' },
  { nu_dne: '525', no_tipo_logradouro: '3º ALTO' },
  { nu_dne: '543', no_tipo_logradouro: '6ª SUBIDA' },
  { nu_dne: '702', no_tipo_logradouro: 'PASSEIO PÚBLICO' },
  { nu_dne: '073', no_tipo_logradouro: 'PASSARELA' },
  { nu_dne: '520', no_tipo_logradouro: '14ª TRAVESSA' },
  { nu_dne: '545', no_tipo_logradouro: '2ª VILA' },
  { nu_dne: '499', no_tipo_logradouro: 'LAGO' },
  { nu_dne: '564', no_tipo_logradouro: 'ESTACIONAMENTO' },
  { nu_dne: '516', no_tipo_logradouro: '10ª TRAVESSA' },
  { nu_dne: '699', no_tipo_logradouro: 'RUA PRINCIPAL' },
  { nu_dne: '473', no_tipo_logradouro: 'JARDINETE' },
  { nu_dne: '538', no_tipo_logradouro: '1ª SUBIDA' },
  { nu_dne: '100', no_tipo_logradouro: 'TRAVESSA' },
  { nu_dne: '104', no_tipo_logradouro: 'VILA' },
  { nu_dne: '072', no_tipo_logradouro: 'PARQUE' },
  { nu_dne: '733', no_tipo_logradouro: 'EIXO' },
  { nu_dne: '511', no_tipo_logradouro: '5ª TRAVESSA' },
  { nu_dne: '507', no_tipo_logradouro: '1ª TRAVESSA' },
  { nu_dne: '070', no_tipo_logradouro: 'PRAIA' },
  { nu_dne: '094', no_tipo_logradouro: 'SERVIDÃO' },
  { nu_dne: '508', no_tipo_logradouro: '2ª TRAVESSA' },
  { nu_dne: '011', no_tipo_logradouro: 'BECO' },
  { nu_dne: '090', no_tipo_logradouro: 'RODOVIA' },
  { nu_dne: '572', no_tipo_logradouro: 'VIA DE ACESSO' },
  { nu_dne: '506', no_tipo_logradouro: 'ROTATÓRIA' },
  { nu_dne: '472', no_tipo_logradouro: 'ÁREA' },
  { nu_dne: '065', no_tipo_logradouro: 'PRAÇA' },
  { nu_dne: '509', no_tipo_logradouro: '3ª TRAVESSA' },
  { nu_dne: '729', no_tipo_logradouro: 'CAMINHO DE SERVIDÃO' },
  { nu_dne: '452', no_tipo_logradouro: 'TRECHO' },
  { nu_dne: '485', no_tipo_logradouro: 'CONDOMÍNIO' },
  { nu_dne: '022', no_tipo_logradouro: 'CORREDOR' },
  { nu_dne: '652', no_tipo_logradouro: 'ENTRE QUADRA' },
  { nu_dne: '105', no_tipo_logradouro: 'VIELA' },
  { nu_dne: '712', no_tipo_logradouro: 'ESTRADA DE SERVIDÃO' },
  { nu_dne: '512', no_tipo_logradouro: '6ª TRAVESSA' },
  { nu_dne: '677', no_tipo_logradouro: 'AVENIDA MARGINAL' },
  { nu_dne: '484', no_tipo_logradouro: 'VIA DE PEDESTRE' },
  { nu_dne: '650', no_tipo_logradouro: 'ESTRADA MUNICIPAL' },
  { nu_dne: '655', no_tipo_logradouro: '1ª AVENIDA' },
  { nu_dne: '666', no_tipo_logradouro: 'VIA LOCAL' },
  { nu_dne: '004', no_tipo_logradouro: 'ALAMEDA' },
  { nu_dne: '690', no_tipo_logradouro: 'ESCADARIA' },
  { nu_dne: '001', no_tipo_logradouro: 'ACESSO' },
  { nu_dne: '077', no_tipo_logradouro: 'QUADRA' },
  { nu_dne: '691', no_tipo_logradouro: '1ª LADEIRA' },
  { nu_dne: '008', no_tipo_logradouro: 'AVENIDA' },
  { nu_dne: '053', no_tipo_logradouro: 'LADEIRA' },
  { nu_dne: '021', no_tipo_logradouro: 'COLÔNIA' },
  { nu_dne: '571', no_tipo_logradouro: 'CALÇADA' },
  { nu_dne: '031', no_tipo_logradouro: 'ESTRADA' },
  { nu_dne: '074', no_tipo_logradouro: 'PASSAGEM' },
  { nu_dne: '727', no_tipo_logradouro: 'VIA PEDESTRE' },
  { nu_dne: '024', no_tipo_logradouro: 'CÓRREGO' },
  { nu_dne: '681', no_tipo_logradouro: 'ESTRADA PARTICULAR' },
  { nu_dne: '713', no_tipo_logradouro: 'COMUNIDADE' },
  { nu_dne: '725', no_tipo_logradouro: 'AVENIDA PERIMETRAL' },
  { nu_dne: '748', no_tipo_logradouro: 'VIA MARGINAL' },
  { nu_dne: '657', no_tipo_logradouro: '3ª AVENIDA' },
  { nu_dne: '667', no_tipo_logradouro: 'ACESSO LOCAL' },
  { nu_dne: '671', no_tipo_logradouro: 'ESTRADA VELHA' },
  { nu_dne: '739', no_tipo_logradouro: 'SERVIDÃO DE PASSAGEM' },
  { nu_dne: '056', no_tipo_logradouro: 'LOTEAMENTO' },
  { nu_dne: '544', no_tipo_logradouro: '1ª VILA' },
  { nu_dne: '020', no_tipo_logradouro: 'CONJUNTO' },
  { nu_dne: '723', no_tipo_logradouro: 'CALÇADÃO' },
  { nu_dne: '101', no_tipo_logradouro: 'VIA' },
  { nu_dne: '698', no_tipo_logradouro: 'RUA PROJETADA' },
  { nu_dne: '487', no_tipo_logradouro: 'RESIDENCIAL' },
  { nu_dne: '052', no_tipo_logradouro: 'JARDIM' },
  { nu_dne: '081', no_tipo_logradouro: 'RUA' },
  { nu_dne: '714', no_tipo_logradouro: 'EIXO INDUSTRIAL' },
  { nu_dne: '510', no_tipo_logradouro: '4ª TRAVESSA' },
  { nu_dne: '095', no_tipo_logradouro: 'SETOR' },
  { nu_dne: '745', no_tipo_logradouro: 'CONJUNTO RESIDENCIAL' },
  { nu_dne: '017', no_tipo_logradouro: 'CAMINHO' },
  { nu_dne: '656', no_tipo_logradouro: '2ª AVENIDA' },
  { nu_dne: '750', no_tipo_logradouro: 'NOVA AVENIDA' },
  { nu_dne: '752', no_tipo_logradouro: 'RUA VICINAL' },
  { nu_dne: '753', no_tipo_logradouro: 'MARGINAL' },
  { nu_dne: '754', no_tipo_logradouro: 'ESCADA DE PEDRA' },
  { nu_dne: '755', no_tipo_logradouro: 'COLINA' },
  { nu_dne: '756', no_tipo_logradouro: 'BECO 1' },
  { nu_dne: '757', no_tipo_logradouro: 'BECO 2' },
  { nu_dne: '758', no_tipo_logradouro: 'BECO 3' },
  { nu_dne: '759', no_tipo_logradouro: 'ACESSO ESTADUAL' },
  { nu_dne: '760', no_tipo_logradouro: 'AVENIDA INTEGRAÇÃO' },
  { nu_dne: '761', no_tipo_logradouro: 'ALÇA DE ACESSO' },
  { nu_dne: '762', no_tipo_logradouro: '7ª AVENIDA' },
  { nu_dne: '763', no_tipo_logradouro: '8ª AVENIDA' },
  { nu_dne: '764', no_tipo_logradouro: '9ª AVENIDA' },
  { nu_dne: '765', no_tipo_logradouro: '10ª AVENIDA' },
  { nu_dne: '766', no_tipo_logradouro: '11ª AVENIDA' },
  { nu_dne: '767', no_tipo_logradouro: 'RODOVIA MUNICIPAL' },
  { nu_dne: '768', no_tipo_logradouro: 'PISTA LATERAL' },
  { nu_dne: '769', no_tipo_logradouro: 'ESTRADA VICINAL MUNICIPAL' },
  { nu_dne: '770', no_tipo_logradouro: 'EDIFÍCIO' },
  { nu_dne: '771', no_tipo_logradouro: 'ESTRADA ECOTURÍSTICA' },
  { nu_dne: '772', no_tipo_logradouro: '26ª TRAVESSA' },
  { nu_dne: '773', no_tipo_logradouro: '6ª VILA' },
  { nu_dne: '774', no_tipo_logradouro: 'ORLA FLUVIAL' },
  { nu_dne: '775', no_tipo_logradouro: 'CHÁCARAS' },
  { nu_dne: '776', no_tipo_logradouro: 'VIA DE CIRCULAÇÃO' },
  { nu_dne: '777', no_tipo_logradouro: 'ALDEIA' },
  { nu_dne: '778', no_tipo_logradouro: '1º ACESSO' },
  { nu_dne: '779', no_tipo_logradouro: '2º ACESSO' },
  { nu_dne: '780', no_tipo_logradouro: '2ª VIA' },
  { nu_dne: '781', no_tipo_logradouro: 'AVENIDA EXPRESSA' },
  { nu_dne: '782', no_tipo_logradouro: 'VIA CIRCULAR' },
  { nu_dne: '783', no_tipo_logradouro: '3º ACESSO' },
  { nu_dne: '784', no_tipo_logradouro: 'TRANSVERSAL' },
  { nu_dne: '785', no_tipo_logradouro: 'DIAGONAL' },
  { nu_dne: '786', no_tipo_logradouro: 'ANEL' },
  { nu_dne: '787', no_tipo_logradouro: 'ALÇA' },
  { nu_dne: '788', no_tipo_logradouro: 'AVENIDA CIRCULAR' },
  { nu_dne: '789', no_tipo_logradouro: 'RUA FERROVIÁRIA' },
  { nu_dne: '790', no_tipo_logradouro: '6º BECO' },
  { nu_dne: '791', no_tipo_logradouro: 'RUA CIRCULAR' },
  { nu_dne: '792', no_tipo_logradouro: 'ESTAÇÃO TRANSFORMADORA' },
  { nu_dne: '793', no_tipo_logradouro: 'LARGO DA BASÍLICA' },
  { nu_dne: '794', no_tipo_logradouro: 'VICINAL' },
  { nu_dne: '795', no_tipo_logradouro: 'TEMPORÁRIO' },
  { nu_dne: '796', no_tipo_logradouro: 'AVENIDA ESPLANADA' },
  { nu_dne: '797', no_tipo_logradouro: 'ESTRADA REAL' },
  { nu_dne: '798', no_tipo_logradouro: 'CONTORNO VIÁRIO' },
  { nu_dne: '799', no_tipo_logradouro: 'PEDESTRE' },
  { nu_dne: '800', no_tipo_logradouro: 'AVENIDA INDUSTRIAL' },
  { nu_dne: '801', no_tipo_logradouro: 'LOTE' },
  { nu_dne: '802', no_tipo_logradouro: 'VIA ESTRADA MUNICIPAL' },
  { nu_dne: '803', no_tipo_logradouro: 'ESCADÃO' },
  { nu_dne: '804', no_tipo_logradouro: 'ACESSO PARA RUA' },
  { nu_dne: '805', no_tipo_logradouro: 'ESTRADA PARA' },
  { nu_dne: '806', no_tipo_logradouro: 'ESTRADA MUNICIPAL PARA' },
  { nu_dne: '807', no_tipo_logradouro: 'PONTILHÃO' },
  { nu_dne: '808', no_tipo_logradouro: 'TREVO ROTATÓRIO' },
  { nu_dne: '809', no_tipo_logradouro: 'PASSAGEM PARTICULAR' },
  { nu_dne: '810', no_tipo_logradouro: 'LIGAÇÃO' },
  { nu_dne: '811', no_tipo_logradouro: 'PRACINHA' },
  { nu_dne: '812', no_tipo_logradouro: 'CENTRO COMERCIAL' },
  { nu_dne: '813', no_tipo_logradouro: 'RUA PEDESTRE' },
  { nu_dne: '814', no_tipo_logradouro: 'PRAÇA E CAMPO' },
  { nu_dne: '815', no_tipo_logradouro: 'RODOVIA VICINAL' },
  { nu_dne: '816', no_tipo_logradouro: 'RUA TRANSVERSAL' },
  { nu_dne: '817', no_tipo_logradouro: 'CALÇADINHO' },
  { nu_dne: '818', no_tipo_logradouro: 'TRAVESSIA' },
  { nu_dne: '819', no_tipo_logradouro: 'AVENIDA NORTE-SUL' },
  { nu_dne: '820', no_tipo_logradouro: 'FOLHA' },
  { nu_dne: '821', no_tipo_logradouro: 'VIA MUNICIPAL' },
  { nu_dne: '822', no_tipo_logradouro: 'VIA CULTURAL' },
  { nu_dne: '824', no_tipo_logradouro: 'OCUPAÇÃO' },
  { nu_dne: '825', no_tipo_logradouro: 'PRAÇA GIRATÓRIA' },
  { nu_dne: '826', no_tipo_logradouro: 'FAIXA' },
  { nu_dne: '827', no_tipo_logradouro: 'ZONA RURAL' },
  { nu_dne: '828', no_tipo_logradouro: 'POVOADO' },
  { nu_dne: '829', no_tipo_logradouro: 'AVENIDA CENTRAL' },
  { nu_dne: '830', no_tipo_logradouro: 'PRAÇA DA MATRIZ' },
  { nu_dne: '831', no_tipo_logradouro: 'PRAÇA ROTATÓRIA' },
  { nu_dne: '832', no_tipo_logradouro: '1ª ESCADARIA' },
  { nu_dne: '833', no_tipo_logradouro: '2ª ESCADARIA' },
  { nu_dne: '834', no_tipo_logradouro: '3ª ESCADARIA' },
  { nu_dne: '835', no_tipo_logradouro: '4ª ESCADARIA' },
  { nu_dne: '836', no_tipo_logradouro: '5ª ESCADARIA' },
  { nu_dne: '837', no_tipo_logradouro: '6ª ESCADARIA' },
  { nu_dne: '838', no_tipo_logradouro: '7ª ESCADARIA' },
  { nu_dne: '839', no_tipo_logradouro: '8ª ESCADARIA' },
  { nu_dne: '840', no_tipo_logradouro: '9ª ESCADARIA' },
  { nu_dne: '841', no_tipo_logradouro: '10ª ESCADARIA' },
  { nu_dne: '842', no_tipo_logradouro: 'EXPANSÃO' },
  { nu_dne: '843', no_tipo_logradouro: 'LOCALIDADE' },
  { nu_dne: '844', no_tipo_logradouro: 'RODOVIA DE ACESSO' },
  { nu_dne: '845', no_tipo_logradouro: 'SISTEMA VIÁRIO' },
  { nu_dne: '846', no_tipo_logradouro: 'ESTRADA MARGINAL' },
  { nu_dne: '847', no_tipo_logradouro: '1ª ESCADA' },
  { nu_dne: '848', no_tipo_logradouro: '2ª ESCADA' },
  { nu_dne: '849', no_tipo_logradouro: 'ENTRADA' },
  { nu_dne: '850', no_tipo_logradouro: 'VICINAL MUNICIPAL' },
  { nu_dne: '851', no_tipo_logradouro: 'RODOVIA ESTADUAL' },
  { nu_dne: '852', no_tipo_logradouro: '1ª TRAVESSA DA RUA' },
  { nu_dne: '853', no_tipo_logradouro: '2ª TRAVESSA DA RUA' },
  { nu_dne: '854', no_tipo_logradouro: '3ª TRAVESSA DA RUA' },
  { nu_dne: '855', no_tipo_logradouro: '4ª TRAVESSA DA RUA' },
  { nu_dne: '856', no_tipo_logradouro: '5ª TRAVESSA DA RUA' },
  { nu_dne: '857', no_tipo_logradouro: 'TRAVESSA DA RUA' },
  { nu_dne: '858', no_tipo_logradouro: 'VIELA DA RUA' },
  { nu_dne: '859', no_tipo_logradouro: 'TRAVESSA PROJETADA' },
  { nu_dne: '860', no_tipo_logradouro: 'BAIRRO' },
  { nu_dne: '861', no_tipo_logradouro: '1ª VIA COLETORA' },
  { nu_dne: '862', no_tipo_logradouro: '2ª VIA COLETORA' },
  { nu_dne: '863', no_tipo_logradouro: 'CENTRO ADMINISTRATIVO' },
  { nu_dne: '864', no_tipo_logradouro: 'RUA CONTORNO' },
]

export function normalizeTexto(v) {
  return (v ?? '')
    .toString()
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export const MAP_TIPO_LOGRADOURO = new Map(
  TIPOS_LOGRADOURO.map((t) => [normalizeTexto(t.no_tipo_logradouro), t.nu_dne])
)
